import { IsNotEmpty } from "class-validator";
import { IArbitrationAddress } from "./arbitration-address.interface";

export class ArbitrationAddressDto implements IArbitrationAddress {
  //
  @IsNotEmpty()
  city: string;

  @IsNotEmpty()
  state: string;

  @IsNotEmpty()
  country: string;
}
